import { SxProps, Theme } from '@mui/material';

export const verticalHeaderCellStyle: SxProps<Theme> = {
  textAlign: 'center',
  padding: '2px',
  border: '1px solid rgba(163, 174, 208, 0.8)',
  verticalAlign: 'bottom',
  minWidth: '44px',
  maxWidth: '100px',
};

export const verticalHeaderStyle: SxProps<Theme> = {
  writingMode: 'vertical-rl',
  transform: 'rotate(180deg)',
  whiteSpace: 'nowrap',
  textAlign: 'center',
  padding: '2px',
  minWidth: '44px',
  maxWidth: '100px',
  display: 'inline-flex',
  flexDirection: 'column',
  alignItems: 'start',
  '& .MuiTypography-root': {
    lineHeight: '13px',
  },
};

export const tableContainerStyle: SxProps<Theme> = {
  borderRadius: '12px',
  boxShadow: 0,
  border: '1px solid rgba(163, 174, 208, 0.8)',
  marginTop: '8px',
};

export const storeTableContainerStyle: SxProps<Theme> = {
  borderRadius: '15px',
  boxShadow: 0,
  border: '1px solid rgba(163, 174, 208, 0.8)'
};

export const noDataCellStyle: SxProps<Theme> = {
  textAlign: 'center',
  padding: '40px 20px',
  border: 'none',
  color: 'rgba(0, 0, 0, 0.6)',
  fontSize: '16px',
  fontStyle: 'italic'
}; 